import { Component } from '@angular/core';

@Component({
  selector: 'rs-profile-not-active',
  templateUrl: 'profile-not-active.component.html',
  styleUrls: ['profile-not-active.component.scss']
})
export class ProfileNotActiveComponent {}
